<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">
        <required-tag v-if="required"></required-tag>
        {{ label }}
      </div>
    </el-col>
    <el-col :span="spanSetting">
      <el-row>
        <el-radio-group v-model="areaType" @change="switchArea($event)">
          <el-radio :label="0" id="radio-area-domestic">国内</el-radio>
          <el-radio :label="1" id="radio-area-foreign">海外</el-radio>
        </el-radio-group>
      </el-row>
      <el-row>
        <el-select
          id="selector-area-top"
          :value="areaTop"
          @change="$emit('change', $event); selectAreaTop($event)"
        >
          <el-option
            v-for="areaItem in areaItemsTop"
            :key="areaItem.id"
            :label="areaItem.name"
            :value="areaItem.id"
            :id="'selector-area-top-option-' + areaItem.id"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <el-select
          id="selector-area-2nd"
          :disabled="areaType == 0"
          :value="area2nd"
          @change="$emit('change', $event); selectArea2nd($event)"
        >
          <el-option
            v-for="areaItem in areaItems2nd"
            :key="areaItem.id"
            :label="areaItem.name"
            :value="areaItem.id"
            :id="'selector-area-2nd-option-' + areaItem.id"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <el-select
          id="selector-area-3rd"
          :disabled="areaType == 0"
          :value="area3rd"
          @change="$emit('change', $event); area3rd = $event"
        >
          <el-option
            v-for="areaItem in areaItems3rd"
            :key="areaItem.id"
            :label="areaItem.name"
            :value="areaItem.id"
            :id="'selector-area-3rd-option-' + areaItem.id"
          >
          </el-option>
        </el-select>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import RequiredTag from '@/components/RequiredTag.vue'
import api from '@/http/api.js'

export default {
  name: 'AreaSelector',
  components: {
    requiredTag: RequiredTag
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    areaType: {
      type: Number,
      default: 0
    },
    value: {
      type: String
    },
    label: {
      type: String
    },
    spanTitle: {
      type: Number
    },
    spanSetting: {
      type: Number
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      areaItemsTop: [],
      areaItems2nd: [],
      areaItems3rd: [],
      areaTop: null,
      area2nd: null,
      area3rd: null
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (this.value.length === 10) {
        var areaCodeTop = this.value.substr(0, 1)
        if (areaCodeTop === '1') {
          api.area.getPrefectures().then(data => {
            this.areaItemsTop = data
            this.areaType = 0
            this.areaTop = this.value
            this.area2nd = ''
            this.area3rd = ''
          })
        } else if (areaCodeTop === '2') {
          api.area.getDistricts().then(data => {
            this.areaItemsTop = data
            this.areaType = 1
            this.areaTop = this.value.substr(0, 4) + '000000'
            if (this.value === this.areaTop) {
              this.area2nd = ''
              this.area3rd = ''
            } else {
              this.areaItems2nd = this.areaItemsTop[this.areaTop].countries
              this.area2nd = this.value.substr(0, 7) + '000'
              if (this.value === this.area2nd) {
                this.area3rd = ''
              } else {
                this.areaItems3rd = this.areaItems2nd[this.area2nd].cities
                this.area3rd = this.value
              }
            }
          })
        }
      }
    }
  },
  methods: {
    switchArea: function (kind) {
      if (kind === 0) {
        api.area.getPrefectures().then(data => {
          this.areaItemsTop = data
          this.areaTop = ''
          this.area2nd = ''
          this.area3rd = ''
        })
      } else {
        api.area.getDistricts().then(data => {
          this.areaItemsTop = data
          this.areaTop = ''
          this.area2nd = ''
          this.area3rd = ''
        })
      }
    },
    selectAreaTop: function (area) {
      this.areaTop = area
      if (this.areaType === 1) {
        this.areaItems2nd = this.areaItemsTop[area].countries
      }
      this.area2nd = ''
      this.area3rd = ''
    },
    selectArea2nd: function (area) {
      this.area2nd = area
      if (this.areaType === 1) {
        this.areaItems3rd = this.areaItems2nd[area].cities
      }
      this.area3rd = ''
    }
  },
  mounted: function () {
    api.area.getPrefectures().then(data => {
      this.areaItemsTop = data
    })
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
div.padding {
  width: 100%;
  height: 100%;
}
</style>
